import Vue from 'vue'

export const exportFiles = {
    state: {
        status: 'idle',
        selectedMerchants: null,
        selectedType: 'smallbusiness',
        promoType:
            'Promo::WeightRegularPrice,Promo::RegularPrice,Promo::PeriodicPriceReduction,Promo::WeightPeriodicPriceReduction',
        downloadQueue: []
    },
    mutations: {
        SET_EXPORT_FILE_STATUS(state, payload) {
            state.status = payload
        },
        SELECT_EXPORT_FILE_MERCHANTS(state, payload) {
            state.selectedMerchants = payload
        },
        SELECT_EXPORT_FILE_TYPE(state, payload) {
            state.selectedType = payload
        },
        SELECT_EXPORT_FILE_PROMO_TYPE(state, payload) {
            state.promoType = payload
        },
        SET_EXPORT_FILE_DOWNLOAD_QUEUE(state, payload) {
            state.downloadQueue.push(payload)
        }
    },
    actions: {
        selectExportFileMerchants({ commit }, payload) {
            commit('SELECT_EXPORT_FILE_MERCHANTS', payload)
        },
        selectExportFileMerchant({ state, commit }, payload) {
            if (payload.value) {
                commit('SELECT_EXPORT_FILE_MERCHANTS', payload)
            } else {
                commit('SELECT_EXPORT_FILE_MERCHANTS', null)
            }
        },
        selectExportFileType({ state, commit }, payload) {
            commit('SELECT_EXPORT_FILE_TYPE', payload)
        },
        selectExportFilePromoType({ state, commit }, payload) {
            commit('SELECT_EXPORT_FILE_PROMO_TYPE', payload)
        },
        async abortExportFileDownload({ state, commit }, payload) {
            const queue = state.downloadQueue.find(e => e.queueId === payload)
            clearInterval(queue.interval)
            commit('SET_EXPORT_FILE_STATUS', 'idle')
        },
        async exportFilesMinio({ state, commit, dispatch }) {
            if (state.status === 'idle') {
                commit('SET_EXPORT_FILE_STATUS', 'loading')
                const exportRes = await this.$api.post('/exporter/export', {
                    file_extension: 'txt',
                    file_type: state.selectedType,
                    merchant_id: state.selectedMerchants.id.toString()
                })
                const queueId = exportRes.data.data.uuid

                const checkQueue = async uuid => {
                    const queueStatus = await this.$api.get(
                        `exporter/status/${uuid}`
                    )
                    const state = queueStatus.data?.data?.state
                    if (state !== 'pending') {
                        dispatch('abortExportFileDownload', queueId)

                        if (state === 'finished') {
                            Vue.prototype.$functions.downloadFile(
                                queueStatus.data.data.file_url,
                                queueStatus.data.data.file_name
                            )
                        } else if (state === 'error') {
                            dispatch('addNotification', {
                                type: 'danger',
                                content:
                                    'Wystąpił błąd. Spróbuj ponownie później.'
                            })
                        }
                    }
                }

                checkQueue(queueId)
                const interval = setInterval(() => {
                    checkQueue(queueId)
                }, 2500)

                commit('SET_EXPORT_FILE_DOWNLOAD_QUEUE', {
                    queueId,
                    interval
                })
            }
        }
    },
    getters: {
        getSelectedExportFileMerchants: state =>
            state.selectedMerchants
                ? [state.selectedMerchants]
                : state.selectedMerchants,
        getExportFileStatus: state => state.status,
        getSelectedExportFileType: state => state.selectedType,
        getSelectedExportFilePromoType: state => state.promoType,
        getExportFileTypes: state => {
            return [
                {
                    label: 'Small Business',
                    value: 'smallbusiness'
                },
                { label: 'PC-Market', value: 'pcmarket' },
                { label: 'Hipermarket', value: 'hipermarket' },
                { label: 'KC-Firma', value: 'kcfirma' }
            ]
        }
    }
}
